import React, { createContext, ReactNode, useContext } from 'react';

declare type EnvVarKeys = 'IM_PREFIX' | 'URF_PREFIX';

interface FreyrLibraryContextType {
  language?: string;
  token?: string;
  tenant?: string;
  domain?: string;
  domainName?: string;
  envVars?: Partial<Record<EnvVarKeys, string>>;
}

export const FreyrLibraryContext = createContext<FreyrLibraryContextType | undefined>(
  undefined
);

type FreyrLibraryProviderProps = FreyrLibraryContextType & {
  children: ReactNode;
};

export const FreyrLibraryProvider: React.FC<FreyrLibraryProviderProps> = ({
  language,
  token,
  tenant,
  domain,
  domainName,
  envVars = {},
  children,
}) => {
  return (
    <FreyrLibraryContext.Provider
      value={{ language, token, tenant, domain, domainName, envVars }}
    >
      {children}
    </FreyrLibraryContext.Provider>
  );
};

export const useFreyrLibraryContext = (): FreyrLibraryContextType => {
  const context = useContext(FreyrLibraryContext);
  if (!context) {
    throw new Error(
      'useFreyrLibraryContext must be used within a FreyrLibraryProvider'
    );
  }
  return context;
};
